import { render, staticRenderFns } from "./FormItemFileCell.vue?vue&type=template&id=8d5b8172&scoped=true"
import script from "./FormItemFileCell.vue?vue&type=script&lang=js"
export * from "./FormItemFileCell.vue?vue&type=script&lang=js"
import style0 from "./FormItemFileCell.vue?vue&type=style&index=0&id=8d5b8172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5b8172",
  null
  
)

export default component.exports